import { Phone, ArrowUpRight } from "lucide-react";

export default function StickyCallBar() {
  return (
    <div
      data-testid="sticky-call-bar"
      className="md:hidden fixed bottom-4 inset-x-4 z-40"
    >
      <div className="flex items-center gap-2 bg-[var(--rr-bg)]/95 backdrop-blur-xl border border-white/10 rounded-full p-1.5 shadow-2xl">
        <a
          href="tel:+16109940500"
          data-testid="sticky-call-btn"
          className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-full bg-[var(--rr-primary)] hover:bg-[var(--rr-primary-hover)] text-white font-semibold text-sm transition-colors"
        >
          <Phone className="h-4 w-4" /> Call 610.994.0500
        </a>
        <a
          href="#quote"
          data-testid="sticky-quote-btn"
          className="inline-flex items-center justify-center gap-1 h-11 px-4 rounded-full text-white text-sm border border-white/10 hover:bg-white/5 transition-colors"
        >
          Quote <ArrowUpRight className="h-3.5 w-3.5" />
        </a>
      </div>
    </div>
  );
}
